import { OtherServices, services, SubServicesdata } from "../../services/data";
import { Heading } from "../../components/Reusable/resuable";
import { useAppSelector } from "../../Redux/hook";
import { FlippingContentCards } from "../../components/Reusable/resuable";
import { useNavigate } from "react-router-dom";
import { DataType } from "../../models/models";
import { Helmet } from "react-helmet-async";
import "./service.scss";

function Equipment() {
    const subServicesdata: DataType = SubServicesdata;
    const navigate = useNavigate();
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return <div className="service">
        <Helmet>
            <title>Equipments - PBL Transport</title>
            <meta
                name="description"
                content="Discover PBL's transport solutions including custom trailers, powerful cranes, versatile axles, and precise forklifts & manlifts – built for every logistics challenge."
            />
            <meta
                name="keywords"
                content="trailers, cranes, axles, forklifts, manlifts, semi-low bed trailers, low bed trailers, all-terrain cranes, 2-axle, 3-axle, 6-axle, transport equipment, logistics solutions"
            />
        </Helmet>
        <Heading lightMode={lightMode} heading="Equipments" />
        <div className="alsoOffer">
            {
                services.map((item, i) => {
                    function nav() {
                        localStorage.setItem('servicetype', item.id.toString())
                        navigate("/mainService");
                    }
                    function content() {
                        return `<div>
                            <div>${item.tagline}</div>
                            <br/>
                            <ul>${subServicesdata[item.id].map((item, i) => `<li>${item.heading}</li>`).join('')}</ul>
                        </div>`
                    }
                    return <FlippingContentCards equipment={true} key={i} subServices={{ id: item.id, heading: item.heading, content: content(), image: item.image, reverse: false }} button={nav} />
                })
            }
        </div>
    </div>
}
function Services() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    var services = [
        {
            name: "Oil & Gas",
            description: "Crane and transport solutions for exploration, maintenance, and refinery operations."
        },
        {
            name: "Energy (Solar & Wind)",
            description: "Crane and ODC transport services for wind turbine components, solar infrastructure."
        },
        {
            name: "Transformers",
            description: "We are specialized in transportation and movement of transformers using specialized trailers and cranes."
        },
        {
            name: "Mining",
            description: "Safe transportation and lifting of heavy mining equipment across rugged terrain."
        },
        {
            name: "Roads & Railways",
            description: "Precision handling of steel materials, precast girders, and bridge construction components."
        },
        {
            name: "PSUs, Plants & Factories",
            description: "Transporting heavy industrial equipment, reactors, and materials for steel, cement, and refinery projects."
        },
        {
            name: "International Operations",
            description: "Crane hire and transport support for projects in Bhutan and Sri Lanka."
        }
    ];
    return <div className="service">
        <Helmet>
            <title>Services - PBL Transport</title>
            <meta
                name="description"
                content="Crane and heavy transport services for Oil & Gas, Renewable Energy, Mining, Railways, Transformers, and more."
            />
            <meta
                name="keywords"
                content="Oil and Gas, Solar, Wind, Mining, Transformers, Railways, Crane Services, Heavy Equipment Transport, Bhutan, Sri Lanka"
            />
        </Helmet>
        {/* <Heading lightMode={lightMode} heading="Our Services" /> */}
        <section className="py-5">
            <div className="container text-center offer">
                <h2 className="mb-4 head" >What We Offer</h2>
                <p className="mb-5">
                    PBL provides specialized crane hire, lifting equipment, and transportation services across multiple industries,
                    ensuring safe and efficient handling of heavy and oversized loads.
                </p>
                <div className="row">
                    {
                        services.map((item, i) => i === 6 ? <span /> : <a style={{ textDecoration: "none" }} href={"#" + item.name} className="col-md-4 mb-4">
                            <div className={`cards p-4 ${lightMode ? 'lightMode' : 'darkMode'}`}>
                                <h3 className="h5">{item.name}</h3>
                                <p>{item.description}</p>
                            </div>
                        </a>)
                    }
                </div>
                <div className="row">
                    <div className="col-md-4 mb-4 desktop"></div>
                    <a style={{ textDecoration: "none", width: "fitcontent", margin: "auto" }} href={"#" + services[6].name} className="col-md-4 mb-4">
                        <div className={`cards p-4 ${lightMode ? 'lightMode' : 'darkMode'}`}>
                            <h3 className="h5">{services[6].name}</h3>
                            <p>{services[6].description}</p>
                        </div>
                    </a>
                    <div className="col-md-4 mb-4 desktop"></div>
                </div>
            </div>
        </section>
        <div className="alsoOffer">
            {
                OtherServices.map((item, i) => <span style={{ scrollMarginTop: "200px" }} id={services[i].name}><FlippingContentCards equipment={false} key={i} subServices={item} /></span>)
            }
        </div>
    </div>
}

export { Services, Equipment };